import { SupplierListPage } from '@/features/supplier/pages/SupplierListPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/supplier/')({
  component: SupplierListPage,
})
